import React, { memo } from "react";
import { Button, Modal } from "react-bootstrap";
import "./style.scss";

const SaveAndExitDialog = ({
  open = false,
  setOpen = () => {},
  onSaveAndExitHandler = () => {},
}) => {
  const onClose = () => {
    setOpen(false);
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title
          style={{ fontSize: "16px", lineHeight: "22px", fontWeight: 500 }}
        >
          Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-3">
        <div style={{ textAlignLast: "center" }}>
          Are you sure you want to save and exit this exam?
        </div>

        <div
          className="d-flex justify-content-end mt-3"
          style={{ gap: "15px" }}
        >
          <Button
            variant="light"
            className="start-classroom-styles px-3"
            style={{
              borderRadius: "20px",
              padding: "8px 36px",
              minWidth: "80px",
            }}
            onClick={onClose}
          >
            No
          </Button>

          <Button
            variant="light"
            className="start-classroom-styles px-3 yesButton"
            style={{
              backgroundColor: "#314CC6",
              color: "white",
              borderRadius: "20px",
              marginRight: "10px",
              padding: "8px 36px",
              minWidth: "80px",
            }}
            onClick={onSaveAndExitHandler}
          >
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(SaveAndExitDialog);
